<template>
  <Menu
    v-bind="getBindValues"
    :activeName="activeName"
    :openNames="getOpenKeys"
    :class="[prefixCls,'main_menu',`${layoutFrame}-simple-menu`]"
    :activeSubMenuNames="activeSubMenuNames"
    @select="handleSelect"
  >
<!--    <SubMenu-->
<!--      name="内部邮箱"-->
<!--    >-->
<!--      <template #title>-->
<!--        <i class="remix-icon ri-mail-send-line" style="font-size: 16px;"></i>-->
<!--        <span class="ml-2 vben-simple-menu-sub-title" title="内部邮箱">内部邮箱</span>-->
<!--      </template>-->
<!--      <email-left-nav />-->
<!--    </SubMenu>-->
    <template v-for="item in items" :key="item.path">
      <SimpleSubMenu
        :item="item"
        :parent="true"
        :collapsedShowTitle="collapsedShowTitle"
        :collapse="collapse"
      />
    </template>
  </Menu>
</template>
<script lang="ts">
import SubMenu from './components/SubMenuItem.vue';
import MenuItem from './components/MenuItem.vue';
import EmailLeftNav from "@/views/innerEmailMg/components/EmailLeftNav.vue";
import type {MenuState} from './types';
import type {Menu as MenuType} from '@/router/types';
import type {RouteLocationNormalizedLoaded} from 'vue-router';
import {defineComponent, computed, ref, unref, reactive, toRefs, watch} from 'vue';
import {useDesign} from '@/hooks/web/useDesign';
import Menu from './components/Menu.vue';
import SimpleSubMenu from './SimpleSubMenu.vue';
import {listenerRouteChange} from '@/logics/mitt/routeChange';
import {propTypes} from '@/utils/propTypes';
import {REDIRECT_NAME} from '@/router/constant';
import {useRouter} from 'vue-router';
import {isFunction, isUrl} from 'xmgoing-utils';
import {getSelItem, openWindow} from '@/utils';

import {useOpenKeys} from './useOpenKeys';
import {StorageUtils} from 'xmgoing-utils';
import { useAppFrame } from '@/hooks/useAppFrame';
import eventBus from '@/events/eventBus';
import { useMultipleTabStore } from '@/store/modules/multipleTab';


export default defineComponent({
  name: 'SimpleMenu',
  components: {
    MenuItem,
    EmailLeftNav,
    SubMenu,
    Menu,
    SimpleSubMenu,
  },
  inheritAttrs: false,
  props: {
    items: {
      type: Array as PropType<MenuType[]>,
      default: () => [],
    },
    collapse: propTypes.bool,
    mixSider: propTypes.bool,
    theme: propTypes.string,
    accordion: propTypes.bool.def(true),
    collapsedShowTitle: propTypes.bool,
    beforeClickFn: {
      type: Function as PropType<(key: string) => Promise<boolean>>,
    },
    isSplitMenu: propTypes.bool,
  },
  emits: ['menuClick'],
  setup(props, {attrs, emit}) {
    const currentActiveMenu = ref('');
    const isClickGo = ref(false);

    const menuState = reactive<MenuState>({
      activeName: '',
      openNames: [],
      activeSubMenuNames: [],
    });
    const { layoutFrame } = useAppFrame();
    const {currentRoute} = useRouter();
    const {prefixCls} = useDesign('simple-menu');
    const {items, accordion, mixSider, collapse} = toRefs(props);
    const tabStore = useMultipleTabStore();

    const {setOpenKeys, getOpenKeys} = useOpenKeys(
      menuState,
      items,
      accordion,
      mixSider,
      collapse,
    );

    const getBindValues = computed(() => ({...attrs, ...props}));

    watch(
      () => props.collapse,
      (collapse) => {
        if (collapse) {
          menuState.openNames = [];
        } else {
          setOpenKeys(currentRoute.value.path);
        }
      },
      {immediate: true},
    );

    watch(
      () => props.items,
      () => {
        if (!props.isSplitMenu) {
          return;
        }
        setOpenKeys(currentRoute.value.path);
      },
      {flush: 'post'},
    );

    listenerRouteChange((route) => {
      if (route.name === REDIRECT_NAME) return;

      currentActiveMenu.value = route.meta?.currentActiveMenu as string;
      handleMenuChange(route);

      if (unref(currentActiveMenu)) {
        const activePath = unref(currentActiveMenu) as string;
        const targetObj: any = { target: null };
        getSelItem(activePath, unref(items), targetObj);
        // 叶子 name 已是菜单 id，不能直接把 path 赋给 activeName
        menuState.activeName = targetObj.target
          ? String(targetObj.target.id || activePath)
          : activePath;
        setOpenKeys(activePath);
      }
    });

    async function handleMenuChange(route?: RouteLocationNormalizedLoaded) {
      if (unref(isClickGo)) {
        isClickGo.value = false;
        return;
      }
      const path = (route || unref(currentRoute)).path;

      const targetObj: any = { target: null };
      getSelItem(path, unref(items), targetObj);
      if (targetObj.target) {
        menuState.activeName = String(targetObj.target.id || path);
      } else {
        menuState.activeName = path;
      }

      setOpenKeys(path);
    }

    async function handleSelect(key: string) {
      StorageUtils.removeSessionItem("curMenuResourceUrl")
      // 仅在「个性化设置」抽屉打开时拦截，避免 analysisSet 标志残留导致菜单无法跳转
      if(window.appObj.analysisSet){
        return false;
      }
      const targetObj:any={target:null};
      getSelItem(key,unref(items),targetObj);
      // 优先用菜单真实 path（含 paramPath），避免 key(入口 id) 被当成路由
      const navPath = (targetObj.target?.paramPath || targetObj.target?.path || key) as string;
      if (targetObj.target) {
        // ACL / 权限仍用 appOldId||id；侧栏消歧用唯一菜单 id
        StorageUtils.addSessionItem("curMenuId",targetObj.target.appOldId||targetObj.target.id);
        StorageUtils.addSessionItem("curMenuEntryId", targetObj.target.id);
        StorageUtils.addSessionItem("curMenuName",targetObj.target.name);
        if(targetObj.target.name){
          document.title=targetObj.target.name;
        }
        if (navPath && targetObj.target.name) {
          StorageUtils.addSessionItem(navPath, targetObj.target.name);
        }
        // 同 path 复用页签时覆盖绑定的菜单入口
        if (targetObj.target.path) {
          tabStore.bindTabMenuEntryId(targetObj.target.path, targetObj.target.id);
        }
        // 同 path 换入口时路由可能不变，通知面包屑按新入口重算
        eventBus.emit('menuEntryChange', {
          entryId: targetObj.target.id,
          path: targetObj.target.path,
        });
      }

      if (navPath.startsWith('/big-screen')) {
        let Url = new URL(navPath, location.origin);
        const sessionId = StorageUtils.getSessionItem("sessionId")!;
        if (!import.meta.env.PROD) {
          Url.port = import.meta.env.VITE_APP_BIG_SCREEN;
          Url.searchParams.set("sessionId", sessionId);
        }

        window.open(Url.toString());

        return
      }

      if (navPath.startsWith('/jieSeriesDashboard')) {
        window.open(new URL(navPath, location.origin).toString(), '_blank');
        return;
      }

      StorageUtils.addSessionItem("curMenuResourceUrl",navPath);
      if (isUrl(navPath)) {
        openWindow(navPath);
        return;
      }
      const {beforeClickFn} = props;
      if (beforeClickFn && isFunction(beforeClickFn)) {
        const flag = await beforeClickFn(navPath);
        if (!flag) return;
      }

      emit('menuClick', navPath);

      isClickGo.value = true;
      setOpenKeys(navPath);
      // 叶子 name 为菜单入口 id，选中态跟 key 走，不能改回 path
      menuState.activeName = key;
    }

    return {
      prefixCls,
      getBindValues,
      handleSelect,
      getOpenKeys,
      ...toRefs(menuState),
      layoutFrame,
    };
  },
});
</script>
<style lang="less">
@import './index.less';
</style>
